// src/components/providerAssignments/StatusChip.tsx

import type { AssignmentStatus } from '../../types/api';
import { STATUS_CHIP, STATUS_LABELS } from './assignmentDisplay';

export function StatusChip({ status }: { status: AssignmentStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${STATUS_CHIP[status]}`}
      data-testid={`assignment-status-${status}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
